export default "__VITE_ASSET__ezss8dyv__"